import { render, staticRenderFns } from "./ClinicDoctors.vue?vue&type=template&id=8e67c68c&scoped=true&"
import script from "./ClinicDoctors.vue?vue&type=script&lang=js&"
export * from "./ClinicDoctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e67c68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDialog,VIcon})
